import { Fragment } from "react";
import { Vehicle } from "../Vehicle/Vehicle";
import { VehiclesProps } from "./Vehicles.types";
import { Divider } from "../../Divider";
import { Card } from "../../Card";
import { Button } from "../../Button";
import styles from "./Vehicles.module.scss";
import { useUrls } from "../../../app/Providers/AppContext";
import { TagAction } from "../../../types/TagAction.types";

const addVehicleTagAction: TagAction = {
  name: "add",
  action: "vehicle_link_clicked",
};

export const Vehicles = ({ policy }: VehiclesProps) => {
  const urls = useUrls();
  const { policyNumber, vehicles, partner, country } = policy;
  const shouldRenderAddVehicle = partner !== "state-farm";

  return (
    <Card width="full" className={styles.container}>
      <h3
        aria-label={`Insured vehicles for policy ${policyNumber}`}
        className={styles.title}
      >
        Insured vehicles
      </h3>
      {vehicles.map((vehicle, index) => (
        <Fragment key={vehicle.id}>
          <Vehicle policy={policy} vehicle={vehicle} />
          {vehicles[index + 1] ? <Divider /> : null}
        </Fragment>
      ))}
      {shouldRenderAddVehicle && (
        <div className={styles.linkContainer}>
          <Button
            variant="outline"
            ariaLabel={`Add vehicle to policy ${policyNumber}`}
            href={urls.insurance.addVehicle(policyNumber, country)}
            tagAction={addVehicleTagAction}
            newTab
          >
            Add vehicle
          </Button>
        </div>
      )}
    </Card>
  );
};
